var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9009 4H8.09906C7.01192 4 5.96931 4.48026 5.20059 5.33513C4.43186 6.18999 4 7.34944 4 8.5584L4 23.4416C4 24.6506 4.43186 25.81 5.20059 26.6649C5.96931 27.5197 7.01192 28 8.09906 28H23.9009C24.9881 28 26.0307 27.5197 26.7994 26.6649C27.5681 25.81 28 24.6506 28 23.4416V8.5584C28 7.34944 27.5681 6.18999 26.7994 5.33513C26.0307 4.48026 24.9881 4 23.9009 4ZM5.8924 23.4416V8.5584C5.89775 7.90942 6.13195 7.2887 6.54463 6.82978C6.9573 6.37086 7.51547 6.11041 8.09906 6.10446H23.9009C24.4869 6.10643 25.0486 6.36513 25.4642 6.82447C25.8798 7.28382 26.1159 7.90681 26.1213 8.5584V21.2308L21.339 17.4321C20.6585 16.8849 19.818 16.6421 18.984 16.7519C18.1501 16.8616 17.3837 17.3159 16.8369 18.0247L10.7566 25.9107H8.09906C7.51312 25.9047 6.95291 25.6422 6.53986 25.18C6.1268 24.7178 5.89417 24.0932 5.8924 23.4416ZM23.9009 25.9107H13.257L18.3057 19.3998C18.5444 19.092 18.878 18.8948 19.2409 18.847C19.6039 18.7992 19.9697 18.9042 20.2664 19.1415L26.0871 23.7987C26.0116 24.384 25.7491 24.9196 25.3477 25.3074C24.9463 25.6953 24.4327 25.9094 23.9009 25.9107Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/Gallery.2b069cbb3eda2dd39e5cb13c2a67bba5.svg";
export { ForwardRef as ReactComponent };